import React from "react";

const Disclosure = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        E.
        <span className="text-[#01A7D1] "> DISCLOSURE</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        We may share the information that we collect about you, including your
        personal information, as follows:
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. INFORMATION DISCLOSED TO PROTECT US AND OTHERS
        </h1>
        We may disclose your information including Personal Information if: (i)
        Yostel reasonably believes that disclosure is necessary in order to
        comply with a legal process (such as a court order, search warrant,
        etc.) or other legal requirement of any governmental authority, (ii)
        disclosure would potentially mitigate our liability in an actual or
        potential lawsuit, (iii) reasonably necessary to enforce this Privacy
        Policy, our terms and conditions etc. (iv) disclosure is intended to
        help investigate or prevent unauthorized transactions or other illegal
        activities, or (v) necessary or appropriate to protect our rights or
        property, or the rights or property of any person or entity.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. INFORMATION DISCLOSED TO THIRD PARTY SERVICE PROVIDERS AND BUSINESS
          PARTNERS
        </h1>
        We may contract with various third parties for the provision and
        maintenance of the Platform, Services and our business operations, and
        Yostel may need to share your personal information and data generated by
        Cookies and aggregate information (collectively, "information") with
        these vendors and service agencies. For example, we may provide your
        information to a credit card processing company to process your payment.
        The vendors and service agencies will not receive any right to use your
        personal information beyond what is necessary to perform its obligations
        to provide the Services to you. If you complete a survey, we also may
        share your information with the survey provider; if we offer a survey in
        conjunction with another entity, we also will disclose the results to
        that entity.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          3. DISCLOSURE TO NON-AFFILIATED THIRD PARTIES IN FURTHERANCE OF YOUR
          REQUEST
        </h1>
        Your request for services may be shared with third party websites with
        whom we have a contractual relationship in order to provide your request
        with maximum exposure. The post on the third party website will include
        the details of your request, including your location, and other contact
        details. Interested bidders, however, will be able to click on your
        request on such third party site, and will be directed to our Platform
        where they will have access to your contact details (Partial or
        complete), as would any other service provider on our Platform
        interested in bidding on your request.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          4. DISCLOSURE TO OTHER USERS OF OUR WEBSITE
        </h1>
        Comments that users post to our Platform also will be available to other
        visitors to our Platform (see our discussion of User Generated Content
        below). In addition, we will post the results (in aggregate form) of
        surveys to our Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          5. INFORMATION DISCLOSED TO LAW ENFORCEMENT OR GOVERNMENT OFFICIALS
        </h1>
        We will disclose your information, including, without limitation, your
        name, city, state, telephone number, email address, user ID history,
        quoting and listing history, and fraud complaints, to law enforcement or
        other government officials if we are required to do so by law,
        regulation or other government authority or otherwise in cooperation
        with an investigation of a governmental authority.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          6. IN THE EVENT OF A CHANGE OF CONTROL OR BANKRUPTCY
        </h1>
        In the event that Yostel undergoes a change in control, including,
        without limitation, a merger or sale of all or substantially all of
        Yostel's assets to which this Platform relates or other corporate
        reorganization in which Yostel participates, and is thus merged with or
        acquired by a third party entity (a "Successor"), Yostel hereby reserves
        the right to transfer the information we have collected from the users
        of the Platform and/or Services to such Successor.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        In addition, in the event of Yostel's bankruptcy, reorganization,
        receivership, or assignment for the benefit of creditors, or the
        application or laws or equitable principles affecting creditors' rights
        generally, Yostel may not be able to control how your information is
        transferred, used, or treated and reserves the right to transfer the
        information we have collected from the users of the Platform and/or
        Services to non-affiliated third parties in such event.
        <br />
        In addition, in the event of Yostel's bankruptcy, reorganization,
        receivership, or assignment for the benefit of creditors, or the
        application or laws or equitable principles affecting creditors' rights
        generally, Yostel may not be able to control how your information is
        transferred, used, or treated and reserves the right to transfer the
        information we have collected from the users of the Platform and/or
        Services to non-affiliated third parties in such event.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          7. INFORMATION DISCLOSED AT YOUR REQUEST
        </h1>
        We may share your personal information with other users or third parties
        to whom you explicitly ask us to send your information or if you
        explicitly consent to such disclosure upon receipt of a specific
        Service.
      </p>
    </div>
  );
};

export default Disclosure;
